import history from '../../history';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updatePartnerMutation as mutation } from '../../lib/graphql';

export const editPartner = (values) => {
  try {
    return async (dispatch, getState, { client }) => {
      let errorMessage = 'Oops! something went wrong. Try again!';

      dispatch(setLoaderStart('EditProvider'));

      const { data } = await client.mutate({
        mutation,
        variables: {
          id: values?.id,
          firstName: values?.firstName,
          lastName: values?.lastName,
          email: values?.email,
          phoneDialCode: values?.phoneDialCode,
          phoneNumber: values?.phoneNumber,
          userStatus: values?.userStatus,
          isBan: values?.isBan,
          phoneCountryCode: values?.phoneCountryCode,
          preferredCurrency: values?.preferredCurrency,
          companyName: values?.companyName,
          workLicenceNumber: values?.workLicenceNumber
        }
      });

      if (data?.updatePartner?.status === 200) {
        history.push('/siteadmin/partners');
        showToaster({ messageId: 'editPartnerSuccess', toasterType: 'success' });
      } else {
        errorMessage = (data?.updatePartner?.errorMessage) ? data?.updatePartner?.errorMessage : errorMessage;
        showToaster({ messageId: 'errorMessage', requestContent: { content: errorMessage }, toasterType: 'error' });
      }
      dispatch(setLoaderComplete('EditProvider'));
    }

  }
  catch (error) {
    dispatch(setLoaderComplete('EditProvider'));
    showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
  }
}